import { useEffect, useRef } from 'react'

// 在文件开头添加重写逻辑
if (typeof window !== 'undefined') {
  const originalSetItem = Storage.prototype.setItem
  Storage.prototype.setItem = function (key: string, value: string) {
    const oldValue = this.getItem(key)
    originalSetItem.call(this, key, value)

    let parsedNewValue, parsedOldValue

    try {
      parsedNewValue = JSON.parse(value)
    } catch (error) {
      console.warn(`JSON解析新值失败，key: ${key}，使用原始值`, error)
      parsedNewValue = value
    }

    try {
      parsedOldValue = oldValue ? JSON.parse(oldValue) : null
    } catch (error) {
      console.warn(`JSON解析旧值失败，key: ${key}，使用原始值`, error)
      parsedOldValue = oldValue
    }

    window.dispatchEvent(
      new CustomEvent('localStorageChange', {
        detail: {
          key,
          newValue: parsedNewValue,
          oldValue: parsedOldValue,
        },
      })
    )
  }
}

export function useLocalStorageListener<T>(key: string, callback: (newValue?: T, oldValue?: T) => void) {
  const prevValue = useRef<T | undefined>(undefined)

  useEffect(() => {
    const handleCustomEvent = (e: CustomEvent<{ key: string; newValue: T; oldValue: T }>) => {
      if (e.detail.key === key) {
        callback(e.detail.newValue, e.detail.oldValue)
        prevValue.current = e.detail.newValue
      }
    }

    window.addEventListener('localStorageChange', handleCustomEvent as EventListener)
    return () => {
      window.removeEventListener('localStorageChange', handleCustomEvent as EventListener)
    }
  }, [key, callback])
}
